import { config } from '../env_config/react-config';
import fetch from './fetchWithTimeout';

export const Services = {
	Post: (url, data) => { 
		return fetch(config.api + url,
			{
				method: "POST", // *GET, POST, PUT, DELETE, etc.
				mode: "cors", // no-cors, cors, *same-origin
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				credentials: "same-origin", // include, same-origin, *omit
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					// "Content-Type": "application/x-www-form-urlencoded",
				},
				redirect: "follow", // manual, *follow, error
				referrer: "no-referrer", // no-referrer, *client
				body: JSON.stringify(data), // body data type must match "Content-Type" header
			}).then(response => response.json()).catch(error => { return error });
	},
	PostWithAuth: (url, data) => {
		return fetch(config.api + url, {
				method: "POST",
				mode: "cors", // no-cors, cors, *same-origin
				headers: new Headers({
					'Authorization': 'Basic '+ btoa('dlcservices:dlcservices@123'),
					"Content-Type": "application/json; charset=utf-8",
				}),
				body: JSON.stringify(data)
			}
		).then(response => response.json()).catch(error => { return error });
	},
	Get: (url) => {
		return fetch(config.api + url)
			.then(function (response) {
				if(response.status === 404){
					return { error: 404 }
				} else {
					return response.json();
				}
			}, err => {
				err.apiError = true;
				throw Error(`Request rejected with status ${err}`);
			}).catch(error => { return error });
	},
	GetWithAuth: (url) => {
		return fetch(config.api+url, {
			method: "GET",
			headers: new Headers({
				'Authorization': 'Basic '+btoa('dlcservices:dlcservices@123'),
				'Content-Type': 'application/json'
			}),
		})
		  .then(function(response) {
			return response.json();
		  }).catch(error => { return error });
	},
	PostWithFile: () => {

	},
	Put: (url, data) => {
		return fetch(config.api + url,
			{
				method: "PUT", // *GET, POST, PUT, DELETE, etc.
				mode: "cors", // no-cors, cors, *same-origin
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				credentials: "same-origin", // include, same-origin, *omit
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					// "Content-Type": "application/x-www-form-urlencoded",
				},
				redirect: "follow", // manual, *follow, error
				referrer: "no-referrer", // no-referrer, *client
				body: JSON.stringify(data), // body data type must match "Content-Type" header
			}).then(response => response.json()).catch(error => { return error });
	},
	Delete: (url, data) => {
		return fetch(config.api + url,
			{
				method: "DELETE", // *GET, POST, PUT, DELETE, etc.
				mode: "cors", // no-cors, cors, *same-origin
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				credentials: "same-origin", // include, same-origin, *omit
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					// "Content-Type": "application/x-www-form-urlencoded",
				},
				redirect: "follow", // manual, *follow, error
				referrer: "no-referrer", // no-referrer, *client
				body: JSON.stringify(data), // body data type must match "Content-Type" header
			}).then(response => response.json()).catch(error => { return error });
	}
}
export default Services;
